import PropTypes from 'prop-types';
import { BoundNew } from '@eti/types';
import { css, cx } from '@eti/styles';
import { getUniqueMarketingCarriersFromSegments } from '../../../../utils/carriers';
import { getBoundAsSegment, getBoundType } from '../../../trip-details/utils/format';
import CartTripBoundInfo from './CartTripBoundInfo';

const wrapperStyles = css`
  margin-bottom: 18px;
  width: 100%;
`;

const boundStyles = css`
  position: relative;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

const CartTripInfo = ({ bounds, className, dataTestId, isMultiStop }) => {
  return (
    <div className={cx(wrapperStyles, className)} data-testid={dataTestId}>
      {bounds?.map((bound, index) => (
        <div
          className={boundStyles}
          data-testid={`cartTrip-bound-${bound.boundId}`}
          key={`boundInfo-${bound.boundId}`}
        >
          <CartTripBoundInfo
            boundId={bound.boundId}
            isMultiStop={isMultiStop}
            marketingCarriers={getUniqueMarketingCarriersFromSegments(bound.segments)}
            segment={getBoundAsSegment(bound.segments, index + 1)}
            type={getBoundType(index)}
          />
        </div>
      ))}
    </div>
  );
};

CartTripInfo.propTypes = {
  bounds: PropTypes.arrayOf(BoundNew),
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  isMultiStop: PropTypes.bool,
};

export default CartTripInfo;
